import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Card,
  WysiwygField,
} from '../../../components';

import './style.scss';

const ParagraphMultipleEntityReference = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const subtitle = entity.getIn(['field_subtitle', 0, 'value']);
  const content = entity.getIn(['field_content']);

  return (
    <Container className="Paragraph ParagraphMultipleEntityReference">
      <div className="row">
        <div className="col-12">
          {title && (
            <h2 className="ParagraphMultipleEntityReference__title">
              {title}
            </h2>
          )}

          <div className="row">
            <div className="col-12 col-md-8 col-lg-6">
              {body && (
                <WysiwygField
                  property="schema:text"
                  className="ParagraphMultipleEntityReference__body subheading2"
                  html={body}
                />
              )}
            </div>
          </div>

          {subtitle && (
            <div className="ParagraphMultipleEntityReference__subtitle subheading2">
              {subtitle}
            </div>
          )}

          {/** FIXME: This has to be node, and not a Card. */}
          {content.size && content.size > 0 && (
            <div className="ParagraphMultipleEntityReference__content">
              <div className="row">
                {content.map((item, index) => {
                  const nodeEntity = item.get('entity');

                  const entityTitle = nodeEntity.getIn(['title', 0, 'value']);
                  const entityBody = nodeEntity.getIn(['body', 0, 'summary']);
                  const type = nodeEntity.getIn(['type', 0, 'target_id']);
                  const link = nodeEntity.getIn(['paths', 'nl']);
                  const uuid = nodeEntity.getIn(['uuid', 0, 'value']);

                  return (
                    <div key={uuid} className="ParagraphMultipleEntityReference__content__card col-12 col-md-6 col-lg-4">
                      <Card small title={entityTitle} body={entityBody} type={type} link={link} />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphMultipleEntityReference;
